import { useCallback } from "react";
import { Avatar, Space, Dropdown, Menu } from "antd";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  UserOutlined,
  LogoutOutlined,
  DownOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useAuthContext } from "@/components/auth/AuthProvider";
import ProfileSetting from "./ProfileSetting";

function UserProfile() {
  const dispatch = useDispatch();
  const auth = useAuthContext();
  const logoutHandler = useCallback(() => {
    dispatch.user.logout();
  }, [dispatch]);
  return (
    <div className="user-profile">
      <Link to="/index" style={{ marginRight: 24 }}>
        首页
      </Link>
      <Dropdown
        overlay={() => (
          <Menu>
            <Menu.Item key={`dropdown-setting`} icon={<SettingOutlined />}>
              <ProfileSetting />
            </Menu.Item>
            <Menu.Item key={`dropdown-logout`} icon={<LogoutOutlined />}>
              <span onClick={logoutHandler}>退出</span>
            </Menu.Item>
          </Menu>
        )}
      >
        <Space>
          <Avatar
            style={{ backgroundColor: "#1e87fb" }}
            icon={<UserOutlined />}
          />
          <span>{auth.username}</span>
          <DownOutlined />
        </Space>
      </Dropdown>
    </div>
  );
}

export default UserProfile;
